import { FaTrophy } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { communityData } from "../../helper/constant";
import moment from "moment";

const Achievement = ({ data }) => {
  return (
    <div className="bg-gradient-to-br from-white to-[#2BACE210] rounded-lg md:shadow-2xl md:border border-blue-100 overflow-hidden mt-4 md:p-4">
      <div className="flex items-center gap-3 mb-4">
        <div className="bg-[#2BACE240] p-2 rounded-lg">
          <FaTrophy className="text-[#2BACE2]" size={20} />
        </div>
        <h2 className="md:text-2xl text-xl font-semibold text-gray-700">
          Achievements
        </h2>
      </div>

      <div>
        {data?.achievementsAndCertifications?.some((item) => item?.title) ? (
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3 max-h-[600px] overflow-y-auto thin-scrollbar">
            {data?.achievementsAndCertifications?.map((item, index) => (
              <div
                key={index}
                className="group bg-white border border-slate-200 mb-2 rounded-2xl p-4 shadow-md relative overflow-hidden"
              >
                {/* Decorative gradient overlay */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-purple-400/10 rounded-full blur-2xl group-hover:scale-150 transition-transform duration-500"></div>

                {/* Category Badge */}
                <div className="flex items-center justify-between mb-4">
                  <span className="inline-block px-3 py-1 bg-gradient-to-r from-[#2BACE2] to-blue-500 text-white text-xs font-semibold rounded-full shadow-md">
                    {item?.categorySelector}
                  </span>
                  <span className="inline-block px-3 py-1 bg-slate-100 text-slate-700 text-xs font-semibold rounded-full">
                    {item?.level}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {item?.title}
                </h3>

                {/* Issuing Organization */}
                <div className="flex items-center gap-2 text-sm text-slate-600 mb-3">
                  <svg
                    className="w-4 h-4 text-blue-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                  <span className="font-medium">
                    {item?.issuingOrganization}
                  </span>
                </div>

                {/* Dates */}
                <div className="grid grid-cols-2 gap-3 mb-4">
                  <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-3 border border-green-100">
                    <p className="text-xs text-green-700 font-semibold mb-1">
                      Issued
                    </p>
                    <p className="text-sm text-slate-700 font-medium">
                      {item?.date && moment(item.date)?.format("DD/MM/YYYY")}
                    </p>
                  </div>
                  <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-3 border border-blue-100">
                    <p className="text-xs text-blue-700 font-semibold mb-1">
                      Valid Until
                    </p>
                    <p className="text-sm text-slate-700 font-medium">
                      {item?.validity && item?.expiry
                        ? moment(item.validity)?.format("DD/MM/YYYY")
                        : "No Expiry"}
                    </p>
                  </div>
                </div>

                {/* Description */}
                {item?.description && (
                  <div className="mb-4 flex gap-1">
                    <span className="text-xs text-slate-500 font-semibold">
                      Description :
                    </span>
                    <p className="text-xs text-slate-600 line-clamp-3">
                      {item.description}
                    </p>
                  </div>
                )}

                {/* Proof Image */}
                {item.proofPath && (
                  <div className="mt-4 pt-4 border-t border-slate-100">
                    <p className="text-xs text-slate-500 font-semibold mb-2">
                      Verification Proof
                    </p>
                    <div className="relative group/img overflow-hidden rounded-xl border">
                      <img
                        src={item?.proofPath}
                        style={{ objectFit: "contain" }}
                        alt="Certification Proof"
                        className="w-full h-40 object-cover rounded-xl shadow-md group-hover/img:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover/img:opacity-100 transition-opacity duration-300 rounded-xl"></div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="py-16 text-center">
            <div className="bg-slate-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
              <FaTrophy className="text-slate-400" size={40} />
            </div>
            <p className="text-slate-600 text-lg font-medium">
              No Achievements Yet
            </p>
            <p className="text-slate-500 text-sm mt-2">
              Start earning certifications to see them here!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Achievement;
